import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import defaultAxiosInstance from "services/client"

interface ExportReportApiResponse extends AxiosResponse {
  data: BlobPart
}

export interface ExportReportApiRequestData
  extends Partial<AxiosRequestConfig> {
  startDt: string
  endDt: string
  bookingNumber: string | null
}
export interface ExportReportApiRequest extends Partial<AxiosRequestConfig> {
  params: ExportReportApiRequestData
}

export async function exportReportApi(
  {
    params,
    method = "get",
    url = `/newadmin/proxy-email-report`,
    ...config
  }: ExportReportApiRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ExportReportApiResponse> {
  return axiosInstance({
    params,
    method,
    url,
    responseType: "blob",
    ...config,
  }) as Promise<ExportReportApiResponse>
}
